import React from 'react'

function Service() {
    return (
        <div className="container-xxl py-5">
            <div className="container py-5 px-lg-5">
                <div className="wow fadeInUp" data-wow-delay="0.1s">
                    <p className="section-title text-secondary justify-content-center"><span />Our Services<span /></p>
                    <h1 className="text-center mb-5">What Solutions We Provide</h1>
                </div>
                <div className="row g-4">

                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                        <div className="service-item d-flex flex-column text-center rounded">
                            <div className="service-icon flex-shrink-0">
                                <i className="fab fa-android fa-2x" />
                            </div>
                            <h5 className="mb-3">App Development</h5>
                            <p className="m-0">Transform your vision into user-centric mobile solutions that captivate users and drive business growth with our expert app development services

                            </p>
                            <a className="btn btn-square" href="#"><i className="fa fa-arrow-right" /></a>
                        </div>
                    </div>


                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="service-item d-flex flex-column text-center rounded">
                            <div className="service-icon flex-shrink-0">
                                <i className="fa fa-laptop-code fa-2x" />
                            </div>
                            <h5 className="mb-3">Web Developement</h5>
                            <p className="m-0">Empower your digital presence with scalable websites that optimize user interaction and business outcomes, crafted through our comprehensive web development services.</p>
                            <a className="btn btn-square" href="#"><i className="fa fa-arrow-right" /></a>
                        </div>
                    </div>



                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="service-item d-flex flex-column text-center rounded">
                            <div className="service-icon flex-shrink-0">
                                <i className="fa fa-user-tie fa-2x" />
                            </div>
                            <h5 className="mb-3">Talent On-Demand</h5>
                            <p className="m-0"> Our tailored staffing solutions ensure you have right skilled professionals to drive projects forward, enhancing efficiency and productivity to meet your business needs seamlessly.</p>
                            <a className="btn btn-square" href="#"><i className="fa fa-arrow-right" /></a>
                        </div>
                    </div>


                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="service-item d-flex flex-column text-center rounded">
                            <div className="service-icon flex-shrink-0">
                                <i className="fa fa-search fa-2x" />
                            </div>
                            <h5 className="mb-3">SEO Optimization</h5>
                            <p className="m-0">Boost your online visibility and attract more visitors with our expert SEO optimization strategies tailored to enhance your website search engine rankings.</p>
                            <a className="btn btn-square" href="#"><i className="fa fa-arrow-right" /></a>
                        </div>
                    </div>



                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="service-item d-flex flex-column text-center rounded">
                            <div className="service-icon flex-shrink-0">
                                <i className="fa fa-paint-brush fa-2x" />
                            </div>
                            <h5 className="mb-3">UI/UX</h5>
                            <p className="m-0">Deliver exceptional user experiences that elevate engagement and satisfaction, tailored to your brand &apos;s identity through our specialized UI/UX design services.

                            </p>
                            <a className="btn btn-square" href="#"><i className="fa fa-arrow-right" /></a>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                        <div className="service-item d-flex flex-column text-center rounded">
                            <div className="service-icon flex-shrink-0">
                                <i className="fab bi-megaphone-fill fa-2x" />
                            </div>
                            <h5 className="mb-3">Social Media Marketing</h5>
                            <p className="m-0">Enhance your online presence with strategic marketing and targeted social media campaigns driving engagement and growth, maximizing visibility for effective business goals.</p>
                            <a className="btn btn-square" href="#"><i className="fa fa-arrow-right" /></a>
                        </div>
                    </div>
                   

                </div>
            </div>
        </div>
    )
}

export default Service